import { Nullable } from 'types'
import { getGraphQLBaseURL } from 'api/url'
import { isE2ETest } from 'services/browserAgent'

/**
 * This method is only used by Relay to connect to our backend, for executing server side queries
 * @param query query as string
 * @param variables variables (if any)
 * @param cookie cookie to use for authentication. This won't be automatically set.
 */
export async function fetchGraphQLRaw(query: string, variables: unknown = {}, cookie?: string) {
  const headers: Record<string, Nullable<string>> = {
    'Content-Type': 'application/json',
    Cookie: cookie, // used in SSR
  }
  if (isE2ETest()) headers.E2ETest = 'true'
  const settings: RequestInit = {
    method: 'POST',
    headers: headers as HeadersInit,
    credentials: 'include', // https://github.com/developit/unfetch#fetchurl-string-options-object
    body: JSON.stringify({
      query,
      variables,
    }),
  }
  return fetch(getGraphQLBaseURL(), settings)
}
